import { lazy } from 'react';
const Protected = lazy(() => import('./Protected'));

// Lazy-loaded components
const Layout = lazy(() => import('../components/Layouts/Layout'));
const TeaserPreLaunch = lazy(() => import('../pages/info/TeaserPreLaunch'));
const PreviewListingPage = lazy(() => import('../pages/PreviewListingPage'));
const AgentPage = lazy(() => import('../pages/AgentPage'));
const BusinessPage = lazy(() => import('../components/business/Businesspage'));
const HuntingPreLaunch = lazy(() => import('../pages/info/HuntingPreLaunch'));
const NetworkPreLaunch = lazy(() => import('../pages/info/NetworkPreLaunch'));
const FormsPreLaunch = lazy(() => import('../pages/info/FormsPreLaunch'));
const ListingGuidelines = lazy(() => import('../pages/info/ListingGuidelinesPage'));
const HowItWorksPage = lazy(() => import('../pages/info/HowItWorksPage'));
const HowHuntWorks = lazy(() => import('../pages/info/HowHuntWorks'));
const TermsOfService = lazy(() => import('../pages/info/TermsOfServicePage'));
const CustomURLPolicy = lazy(() => import('../pages/info/CustomURLPolicy'));
const ContentPolicy = lazy(() => import('../pages/info/ContentPolicy'));
const LandingPage = lazy(() => import('../pages/info/news/LandingPage'));
const BusinessProfile = lazy(() => import('../pages/info/news/BusinessProfile'));
const News = lazy(() => import('../pages/info/news/News'));
const AboutUs = lazy(() => import('../pages/info/AboutUs'));
const Listing = lazy(() => import('../pages/Listing'));
const PrivacyPolicy = lazy(() => import('../pages/info/PrivacyPolicy'));
const LoginPage = lazy(() => import('../pages/LoginPage'));
const RegisterPage = lazy(() => import('../pages/RegisterPage'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPasswordPage'));
const UpdatePasswordPage = lazy(() => import('../pages/UpdatePasswordPage'));
const VerifyAccountPage = lazy(() => import('../components/auth/VerifyAccountPage'));
const VerifyInvitationPage = lazy(() => import('../pages/VerifyInvitationPage'));
const SalesPreLaunch = lazy(() => import('../pages/info/SalesPreLaunch'));
const AllResultsPage = lazy(() => import('../pages/AllResultsPage'));
const SearchResultPage = lazy(() => import('../pages/SearchResultPage'));
const ExtendHuntPage = lazy(() => import('../components/huntingBoard.tsx/ExtendHuntPage'));

const ListingPage = lazy(() => import('../pages/ListingPage'));
// const AdsLandingPage = lazy(() => import('../pages/AdsLandingPage'));
// const AdsAgentLandingPage = lazy(() => import('../pages/AdsAgentLandingPage'));
const CommunityPage = lazy(() => import('../pages/community/CommunityPage'));
const SquarePage = lazy(() => import('../pages/square/SquarePage'));
const PostPage = lazy(() => import('../components/square/PostPage'));

// const AdsLandingPage = lazy(() => import('../pages/AdsLandingPage'));
// const AdsAgentLandingPage = lazy(() => import('../pages/AdsAgentLandingPage'));

export const layoutRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/messenger', element: <TeaserPreLaunch /> },
      { path: '/properties/preview/:id/:title?', element: <PreviewListingPage /> },
      { path: '/member/:id', element: <AgentPage /> },
      { path: '/business/:id', element: <BusinessPage /> },
      { path: '/huntingboard', element: <HuntingPreLaunch /> },
      { path: '/network', element: <NetworkPreLaunch /> },
      { path: '/forms', element: <FormsPreLaunch /> },
      { path: '/listing-guidelines', element: <ListingGuidelines /> },
      { path: '/terms-of-service', element: <TermsOfService /> },
      { path: '/custom-url-policy', element: <CustomURLPolicy /> },
      { path: '/content-policy', element: <ContentPolicy /> },
      { path: '/news', element: <LandingPage /> },
      { path: '/news/business-profile', element: <BusinessProfile /> },
      { path: '/launch', element: <News /> },
      { path: '/about', element: <AboutUs /> },
      { path: '/listing', element: <Listing /> },
      { path: '/privacy-policy', element: <PrivacyPolicy /> },
      { path: '/how-it-works', element: <HowItWorksPage /> },
      { path: '/how-hunt-works', element: <HowHuntWorks /> },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/register',
        element: <RegisterPage />,
      },
      { path: '/reset-password', element: <ResetPasswordPage /> },
      { path: '/users/reset_password_received/:userId/:token', element: <UpdatePasswordPage /> },
      { path: '/users/verify_account/:userId/:token', element: <VerifyAccountPage /> },
      { path: '/invitation/:userId/:token', element: <VerifyInvitationPage /> },
      { path: '/appointsalesrep', element: <SalesPreLaunch /> },
      { path: '/all', element: <AllResultsPage /> },
      { path: '/results/:type', element: <SearchResultPage /> },
      { path: '/still-hunting/:huntId', element: <ExtendHuntPage /> },
      { path: '/properties/:id/:title?', element: <ListingPage /> },
      {
        path: '/community',
        element: (
          <Protected>
            <CommunityPage />
          </Protected>
        ),
      },
      { path: '/square', element: <SquarePage /> },
      { path: '/square/post/:postId/:title?', element: <PostPage /> },
      // { path: '/homes/:country/:city/:title/:id', element: <ListingPage /> },
      // { path: '/property-search/thailand', element: <AdsLandingPage type="th" /> },
      // { path: '/property-search/sri-lanka', element: <AdsLandingPage type="sl" /> },
      // { path: '/list-property/thailand', element: <AdsAgentLandingPage type="th" /> },
      // { path: '/list-property/sri-lanka', element: <AdsAgentLandingPage type="sl" /> },
    ],
  },
];
